function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import * as S from './TextAreaBase.styles';
export const TextAreaBase = /*#__PURE__*/React.forwardRef(({
  hasError,
  id,
  inputState,
  size,
  rows,
  cols,
  ...baseProps
}, ref) => {
  return /*#__PURE__*/React.createElement(S.TextArea, _extends({
    id: id,
    ref: ref,
    "aria-invalid": hasError,
    rows: rows ?? 4,
    $state: inputState,
    $size: size
  }, baseProps));
});